/**
 * Movimento dos ícones da casca do backoffice, o mesmo do botão "CLT vs PJ" do
 * capitalizae.com (padrão davincii): no hover o ícone gira um pouco para a
 * esquerda e cresce; ao ficar ativo / ser clicado ele dá o "pop" (cresce além,
 * balança e assenta). O pop precisa de `key` no ícone, para recomeçar a cada troca.
 */

/** Hover: gira −12° e cresce 10%. Exige `group` no pai. */
export const ICON_HOVER =
  "transition-transform duration-200 ease-out motion-reduce:transition-none group-hover:-rotate-12 group-hover:scale-110";

/** Clique / ficou ativo: scale .6 → 1.25 → 1 com rotação −12° → 6° → 0 (0,5s). */
export const ICON_POP = "animate-hermes-icon-pop motion-reduce:animate-none";
